import { Input, ViewEncapsulation } from '@angular/core';
import { Component, OnInit } from '@angular/core';

import moment from 'moment';
import { finalize } from 'rxjs';
import { Appointment } from 'src/models/appointment';
import { User } from 'src/models/user';
import { Workshop } from 'src/models/workshop';
import { APICustomdashboardService } from 'src/services/api-services/api-custom-dashboard';
import { APICustomScheduleService } from 'src/services/api-services/api-custom-schedule-service';
import { APICustomerBasicDataService } from 'src/services/api-services/api-customer-basic-data-service';
import { CustomSchedule } from 'src/services/api-services/api-interfaces/custom-schedule.interface';
import { Scheduler } from 'src/services/api-services/api-interfaces/scheduler.interface';
import { APISchedulerService } from 'src/services/api-services/api-scheduler-service';
import { APIService } from 'src/services/api-services/api-service';

import { APIServiceSchedule } from 'src/services/api-services/api-service-schedule';
import { APIUserDealerService } from 'src/services/api-services/api-user-dealer';
import { APIWorkshopService } from 'src/services/api-services/api-workshop.service';
import { HelperService } from 'src/services/helperService';
import { id } from '@swimlane/ngx-charts';
import { dashboardDateService } from '../../../services/dashboardDateService.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.sass'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CalendarComponent implements OnInit {
  customScheduleResp: any[] = [];
  isLoading: boolean = true;
  constructor(
    public ScheduleService: APIServiceSchedule,
    public Service: APIService,
    public customerbasicdataService: APICustomerBasicDataService,
    public WorkshopService: APIWorkshopService,
    public schedulerService: APISchedulerService,
    public customScheduleService: APICustomScheduleService,
    public helperService: HelperService,
    public UserDealerservice: APIUserDealerService,
    public DashboardService: APICustomdashboardService,
    public date: dashboardDateService,
    private translate: TranslateService
  ) {
     ;
  }

  fecha: Date = new Date();
  startWeek: string=''
  endWeek: string=''
  data_change() {
    var today = new Date();
    var now = today.getHours();
    this.isLoading = false;
    this.onDayClick(this.selectedDay);
  }
  UserDealersData: any[] = [];
  workshopsData: Workshop[] = [];

  client: any[] = [];

  isClearDisabled(): boolean {
    // function to enable clear button conditionally
    let isDisabled = true;

    if (this.appointmentsData.length <= 5) {
      //if any filter is filled the button will be enabled
      isDisabled = false;
    }
    return isDisabled;
  }
  appointmentsData: any[] = [];
  weekInEs: string[] = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];

  @Input() years: string[] = [];
  @Input() isCalendarCollapsed: boolean = false;

  selectedMonth: number = 0;
  days: number[] = new Array<number>(5);
  selectedDay: number = 0;
  selectedDayMonth: number = 0;
  currentYear: number = 0;
  daysInSelectedMonth: number = 0;
message='Mensaje enviado'

  private cleanClientFullName(value: any): string {
    const s = String(value ?? '').trim();
    return s.replace(/\bNaN\b.*$/, '').trim();
  }

getCalendar() {

  switch (this.helperService.user.role.roleId) {
    case 1:
      this.DashboardService?.getCalendar(this.helperService.user.role.roleId, this.helperService.user.countryId, this.helperService.user.advisorId)
        .pipe(finalize(() => this.data_change()))
        .subscribe({
          next: (response) => {
            if (!response.message) {
              this.customScheduleResp = response
                .map((a: any) => ({
                  ...a,
                  clientFullName: this.cleanClientFullName(a.clientFullName),
                }))
                .sort((a: Appointment, b: Appointment) => a.time.localeCompare(b.time));
            } 
          },
          error: (error) => {
            if(error.status === 401){
              this.helperService.logoutToken()
            }
            console.error('No se pudo obtener la data por pipe', error);
          },
        });
      break;
      case 2:
      case 6:
        this.DashboardService?.getCalendar(this.helperService.user.role.roleId, this.helperService.user.countryId, this.helperService.user.workshopId)
        .pipe(finalize(() => this.data_change()))
        .subscribe({
          next: (response) => {
            if (!response.message) {
              this.customScheduleResp = response
                .map((a: any) => ({
                  ...a,
                  clientFullName: this.cleanClientFullName(a.clientFullName),
                }))
                .sort((a: Appointment, b: Appointment) => a.time.localeCompare(b.time));
            } 
          },
          error: (failed) => {
            if(failed.status === 401){
              this.helperService.logoutToken()
            }
            console.error('No se pudo obtener la data por pipe', failed);
          },
        });
      break;
      case 3:
        this.DashboardService?.getCalendar(this.helperService.user.role.roleId, this.helperService.user.countryId)
        .pipe(finalize(() => this.data_change()))
        .subscribe({
          next: (response) => {
            if (!response.message) {
              this.customScheduleResp = response
                .map((a: any) => ({
                  ...a,
                  clientFullName: this.cleanClientFullName(a.clientFullName),
                }))
                .sort((a: Appointment, b: Appointment) => a.time.localeCompare(b.time));
            } 
          },
          error: (failed) => {
            if(failed.status === 401){
              this.helperService.logoutToken()
            }
            console.error( failed);
          },
        });
      break;

    default:
      break;
  }

}

  ngOnInit(): void {
    this.userProfile = this.helperService.user;
    this.getCalendar();
    let currentDate = moment();
    this.selectedMonth = currentDate.month() + 1;
    this.selectedDayMonth = this.selectedMonth;
    this.currentYear = currentDate.year();
    this.selectedDay = currentDate.date();
    this.setDisplayedDays(this.selectedDay);
    this.sendMonth(this.years[this.selectedMonth - 1])
  }

  prevMonth() {
    if (this.selectedMonth > 0) {
      this.selectedMonth--;
      this.setDisplayedDays(3);
      const monthName=this.years[this.selectedMonth - 1]
      this.sendMonth(monthName)
    }
  }
    getWeekPositionMonthBased(day: number, week:number,month:string,) {
    // 0 for start - 6 for end
      const today = new Date();
      const dayOfWeek = today.getDay();
      const diff = today.getDate() + (day - dayOfWeek) + (dayOfWeek === 0 ? -6 : 1);
      return new Date(today.setDate(diff)).toISOString().split('T')[0]; 
    }
  
  nextMonth() {
    if (this.selectedMonth < this.years.length) {
      this.selectedMonth++;
      this.setDisplayedDays(3);
      const monthName=this.years[this.selectedMonth - 1]
      this.sendMonth(monthName)
      
    }
  }
  sendMonth(monthName:string) {
    this.date.changeMessage(monthName);
  }
  isDayOfTheMonthValid(day: number): boolean {
    return moment(
      `${this.currentYear}-${this.selectedMonth}-${day}`,
      'YYYY-MM-DD'
    ).isValid();
  }
  setDisplayedDays(day: number) {
    //Re-calibrate displayed day in the middle
    if (!this.isDayOfTheMonthValid(day - 1)) {
      day = day + 2;
    }
    if (!this.isDayOfTheMonthValid(day - 2)) {
      day = day + 1;
    }
    if (!this.isDayOfTheMonthValid(day + 1)) {
      day = day - 1;
    }
    if (!this.isDayOfTheMonthValid(day + 2)) {
      day = day - 1;
    }
    this.days[0] = day - 2;
    this.days[1] = day - 1;
    this.days[2] = day;
    this.days[3] = day + 1;
    this.days[4] = day + 2;
    this.daysInSelectedMonth = moment(
      `${this.currentYear}-${this.selectedMonth}`,
      'YYYY-MM'
    ).daysInMonth();
  }

  getDayOfWeekInEs(
    day: number,
    month: number,
    isSliced: boolean = false
  ): string {
    let dayOfWeek = moment(
      `${this.currentYear}-${month}-${day}`,
      'YYYY-MM-DD'
    ).day();
    return isSliced
      ? this.weekInEs[dayOfWeek].slice(0, 2)
      : this.weekInEs[dayOfWeek];
  }

  prevWeek() {
    if (this.days[0] - 1 > 0) {
      this.days.forEach((day, index) => {
        this.days[index] = day - 1;
      });
    }
  }

  nextWeek() {
    if (this.days[4] + 1 <= this.daysInSelectedMonth) {
      this.days.forEach((day, index) => {
        this.days[index] = day + 1;
      });
    }
  }
  userProfile?: User;
  onDayClick(day: number) {
    this.selectedDay = day;
    this.selectedDayMonth = this.selectedMonth;
    let date = new Date(
      this.selectedMonth + '/' + this.selectedDay + '/' + this.currentYear
    );

    switch (this.helperService.user.role.roleId) {
      case 4:
        break;
      case 1:
        this.appointmentsData = [];
        this.appointmentsData = this.customScheduleResp.filter(
          (s) =>
            new Date(s.date).toLocaleDateString() === date.toLocaleDateString()
        );
        break;
      case 2:
      case 6:
        this.appointmentsData = [];
        this.appointmentsData = this.customScheduleResp.filter(
          (s) =>
            new Date(s.date).toLocaleDateString() === date.toLocaleDateString()
        );

        break;
      case 3:
        this.appointmentsData = [];
        this.appointmentsData = this.customScheduleResp.filter(
          (s) =>
            new Date(s.date).toLocaleDateString() === date.toLocaleDateString()
        );
        break;

      default:
        this.appointmentsData = [];
        this.appointmentsData = this.customScheduleResp.filter(
          (s) =>
            new Date(s.date).toLocaleDateString() === date.toLocaleDateString()
        );
        break;
    }

    this.isClearDisabled();
  }
}
